import { error } from "./logger";
const storage = {};

export const loadFromCache = async (key, retrieveFunction) => {
    if (!storage.hasOwnProperty(key)) {
        if (!retrieveFunction) {
            error("CacheService: loadFromCache: retrieveFunction is not defined");

            return null;
        }

        storage[key] = retrieveFunction(key);
    }

    return storage[key];
};
export const updateCache = (key, value) => {
    storage[key] = value;

    return value;
};
